export const errorCode = {
  USER_LOCKED: 'User has been locked!',
  INCORRECT_PASSWORD: 'Wrong email or password!',
  TOKEN_INVALID: 'Token invalid!',
  NOT_VERIFIED_2FA: 'NOT_VERIFIED_2FA',
  INCORRECT_GOOGLE_CODE: 'INCORRECT_GOOGLE_CODE',
  INCORRECT_EMAIL_CODE: 'INCORRECT_EMAIL_CODE',
};
export enum ErrorCodeLogin {
  INCORRECT_PASSWORD = 'INCORRECT_PASSWORD',
  NO_COMMISSION_RATE = 'NO_COMMISSION_RATE',
  USER_DISABLE = 'USER_DISABLE',
  USER_DELETED = 'USER_DELETED',
  USER_LOCKED = 'USER_LOCKED',
  TOKEN_INVALID = 'TOKEN_INVALID',
}
